module.exports = {
  'en-us': {
    dmca: {
      title: 'Submit a Take-Down Notice',
      nameLabel: 'Your name',
      emailLabel: 'Your email address',
      infringingUrlLabel: 'Where is the infringing content? (Page - not general website - of the resources infringing copyright: www.google.com/exactInfringingPage)',
      ownershipStatementLabel: 'Statement of the ownership of this content',
      submitButtonText: 'Submit',
      failedRequest: {
        text: 'Unable to process request. Please submit an email to {0} with the information in the form below.',
      },
    },
  },
  fr: {
    dmca: {
      title: 'Soumettre un avis de retrait',
      nameLabel: 'Votre nom',
      emailLabel: 'Votre adresse email',
      infringingUrlLabel: "Où est le contenu contrefait ? (Page - pas le site Web général - des ressources portant atteinte au droit d'auteur : www.google.com/pageeninfractionexacte)",
      ownershipStatementLabel: 'Déclaration de propriété de ce contenu',
      submitButtonText: 'Soumettre',
      failedRequest: {
        text: 'Impossible de traiter la demande. Veuillez envoyer un e-mail à {0} avec les informations dans le formulaire ci-dessous.',
      },
    },
  },
  it: {
    dmca: {
      title: 'Invia un avviso di rimozione',
      nameLabel: 'Il tuo nome',
      emailLabel: 'Il tuo indirizzo di posta elettronica',
      infringingUrlLabel: "Dov'è il contenuto illecito? (Pagina - sito web non generico - delle risorse che violano il copyright: www.google.com/paginainviolazioneesatta)",
      ownershipStatementLabel: 'Dichiarazione di proprietà di questo contenuto',
      submitButtonText: 'Invia',
      failedRequest: {
        text: "Impossibile elaborare la richiesta. Invia un'email a {0} con le informazioni nel modulo sottostante.",
      },
    },
  },
  ja: {
    dmca: {
      title: '削除通知を送信する',
      nameLabel: 'あなたの名前',
      emailLabel: 'メールアドレス',
      infringingUrlLabel: '権利を侵害しているコンテンツはどこにありますか？ （著作権を侵害しているリソースのページ-一般的なウェブサイトではありません：www.google.com/正確な著作権侵害ページ）',
      ownershipStatementLabel: 'このコンテンツの所有権に関する声明',
      submitButtonText: '参加する',
      failedRequest: {
        text: 'リクエストを処理できません。以下のフォームに情報を記載したメールを{0}に送信してください。',
      },
    },
  },
  pt: {
    dmca: {
      title: 'Envie um Aviso de Retirada',
      nameLabel: 'Seu nome',
      emailLabel: 'Seu endereço de email',
      infringingUrlLabel: 'Onde está o conteúdo infrator? (Página - não site geral - dos recursos que violam direitos autorais: www.google.com/páginainfratoraexata)',
      ownershipStatementLabel: 'Declaração de propriedade deste conteúdo',
      submitButtonText: 'Enviar',
      failedRequest: {
        text: 'Incapaz de processar o pedido. Envie um e-mail para {0} com as informações do formulário abaixo.',
      },
    },
  },
  es: {
    dmca: {
      title: 'Envíe un aviso de eliminación',
      nameLabel: 'Tu nombre',
      emailLabel: 'Su dirección de correo electrónico',
      infringingUrlLabel: '¿Dónde está el contenido infractor? (Página, no sitio web general, de los recursos que infringen los derechos de autor: www.google.com/páginainfractoraexacta)',
      ownershipStatementLabel: 'Declaración de propiedad de este contenido',
      submitButtonText: 'Enviar',
      failedRequest: {
        text: 'No se puede procesar la solicitud. Envíe un correo electrónico a {0} con la información del formulario a continuación.',
      },
    },
  },
};
